export default __webpack_public_path__ + "0819f644a02429b885a46cc6c8129d96.png";